// src/support/chartStyleValueUtils.ts

/**
 * Normalize borderColor inputs:
 * - 'inherit' => { from: 'color' }
 * - 'theme'   => { theme: 'labels.text.fill' } (or a theme path you prefer)
 * - '#RRGGBB' => '#RRGGBB'
 * - object    => object
 */
export function normalizeNivoBorderColor(input: any) {
  if (!input) return undefined;
  if (input === 'inherit') return { from: 'color' };
  if (input === 'theme') return { theme: 'labels.text.fill' };
  if (typeof input === 'string') return input;
  if (typeof input === 'object') return input;
  return undefined;
}
